// extracted by mini-css-extract-plugin
export default {"blockingArea":"style_blockingArea__nIHPL"};